import { MdPictureInPictureAlt } from "react-icons/md";

import { Button } from "components/button";
import globalStyles from "index.module.css";

import styles from "./index.module.css";

export const PipActiveOverlay = ({ onClose }: { onClose: () => void }) => (
  <div className={globalStyles.container}>
    <div className={styles.card}>
      <MdPictureInPictureAlt className={styles.icon} size={48} />
      <h2 className={styles.title}>Picture-in-Picture Active</h2>
      <p className={styles.description}>Your call is now displayed in a floating window.</p>
      <Button onClick={onClose} variant="white">
        Exit
      </Button>
    </div>
  </div>
);
